module.exports = __webpack_public_path__ + "img/i18b.070c03d9.svg";